import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const Logout: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const [logging_out, setLoggingOut] = useState<boolean>(false);

  const getSession = () => {
    return cookies.get('oasis_session' + api.getSubDomain())
  }

  useEffect(() => {
    // console.log(store.is_impersonating, getSession())
    if (logging_out) {
      setTimeout(() => {
        if (!getSession()) {
          location.replace('#/login');
        }
        else {
          location.replace('#/impersonate/reset');
        }
      }, 1);
    }
  }, [store.is_impersonating, getSession()]);

  useEffect(() => {
    if (!getSession()) {
      location.replace('#/login');
    }
    else {
      setLoggingOut(true);
      api.logout();
    }
  }, []);

  return (
    <div />
  );
}

export default Logout;